import { useEffect, useState } from "react";
import { TouchAppOutlinedIcon } from "./icons";
import { useSelector } from "react-redux";
import "../../styles/RestingWall.css";

export default function RestingWall() {
  const [current, setCurrent] = useState(0);
  const { pictureUrl, isSelfcheckoutTotem, selfcheckoutConfigs } = useSelector(
    (state) => state.shop,
  );

  const selfcheckoutConfig =
    selfcheckoutConfigs?.length > 0 ? selfcheckoutConfigs[0] : {};

  const banners = [
    selfcheckoutConfig.pictureUrlBanner1,
    selfcheckoutConfig.pictureUrlBanner2,
    selfcheckoutConfig.pictureUrlBanner3,
    selfcheckoutConfig.pictureUrlBanner4,
    selfcheckoutConfig.pictureUrlBanner5,
    selfcheckoutConfig.pictureUrlBanner6,
  ].filter((banner) => !!banner);

  useEffect(() => {
    if (banners.length <= 1) return;
    const interval = setInterval(() => {
      setCurrent((c) => (c + 1) % banners.length);
    }, 10000);
    return () => {
      clearInterval(interval);
    };
  }, [current, banners.length]);

  if (banners.length === 0) {
    return (
      <div
        className={`totem-rest${isSelfcheckoutTotem ? " totem-rest--large" : ""}`}
      >
        {pictureUrl && (
          <img
            src={pictureUrl}
            alt="Logo da loja"
            className="totem-rest__logo"
          />
        )}
        <h1 className="totem-rest__title">Faça seu pedido aqui</h1>
        <p className="totem-rest__cta">
          <TouchAppOutlinedIcon /> Toque para começar
        </p>
      </div>
    );
  }

  return (
    <section aria-label="Autoatendimento banners">
      <div className="carousel" data-carousel>
        <ul data-slides>
          {banners.map((banner, index) => (
            <li
              key={banner}
              className={index === current ? "slide slide-active" : "slide"}
            >
              <img src={banner} alt={`Banner ${index}`} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
